/**
 * Takes api params and converts them inot a JSON api friendly format
 * * Map: Arrays as string
 * * Recursively looks down the structure
 *
 * @param {*} attributes
 * @returns
 */
function transformAttributesForApi (attributes = {}) {
  if (typeof attributes !== 'object') {
    return attributes
  }

  return Object.entries(attributes).reduce((attrs, [key, val]) => {
    if (Array.isArray(val)) {
      return { ...attrs, [key]: val.toString() }
    } else if (typeof val === 'object') {
      return { ...attrs, [key]: transformAttributesForApi(val) }
    }

    return { ...attrs, [key]: val }
  }, {})
}

export default transformAttributesForApi
